module.exports = __webpack_public_path__ + "static/media/research-7.aae536aa.svg";